import { styled } from '@linaria/react';
import { bodyFont, fonts, semantic, space } from '../../theme/tokens';

export const EmptyMessage = styled.p`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  color: ${semantic.text.secondary};
  text-align: center;
  padding: ${space[9]} 0;
`;
